import { putData, postData, getData } from '../plugins/ApiCalls'

/**
 * Subscribe to a plan - returns checkout URL
 * @param {Object} data - { plan_id, success_url?, coupon_code? }
 */
export function subscribePlan(data) {
  return postData('plans/subscribe', data)
}

/**
 * Change plan (upgrade/downgrade)
 * @param {Object} data - { plan_id }
 */
export function changePlan(data) {
  return putData('plans/change-plan', data)
}

/**
 * Cancel subscription
 */
export function cancelPlan() {
  return postData('plans/cancel')
}

/**
 * Pause subscription
 */
export function pausePlan() {
  return postData('plans/pause')
}

/**
 * Resume subscription
 */
export function resumePlan() {
  return postData('plans/resume')
}

/**
 * Get all available plans
 */
export function getPlans() {
  return getData('plans')
}

/**
 * Get subscription details for a specific plan
 * @param {Number} planId
 */
export function planSubscription(planId) {
  return getData('plans/' + planId + '/subscription')
}
